var items = {
  "block.minecraft.air": "levegő",
  "block.minecraft.stone": "kő",
  "block.minecraft.granite": "gránit",
  "block.minecraft.polished_granite": "csiszolt gránit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "csiszolt diorit",
  "block.minecraft.andesite": "andezit",
  "block.minecraft.polished_andesite": "csiszolt andezit",
  "block.minecraft.grass_block": "füves földblokk",
  "block.minecraft.dirt": "föld",
  "block.minecraft.coarse_dirt": "terméketlen föld",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "karmazsin nílium",
  "block.minecraft.warped_nylium": "torz nílium",
  "block.minecraft.cobblestone": "zúzottkő",
  "block.minecraft.oak_planks": "tölgydeszka",
  "block.minecraft.spruce_planks": "fenyődeszka",
  "block.minecraft.birch_planks": "nyírfa deszka",
  "block.minecraft.jungle_planks": "dzsungelfa deszka",
  "block.minecraft.acacia_planks": "akáciadeszka",
  "block.minecraft.dark_oak_planks": "sötéttölgy deszka",
  "block.minecraft.crimson_planks": "karmazsin deszka",
  "block.minecraft.warped_planks": "torz deszka",
  "block.minecraft.oak_sapling": "tölgycsemete",
  "block.minecraft.spruce_sapling": "fenyőcsemete",
  "block.minecraft.birch_sapling": "nyírfacsemete",
  "block.minecraft.jungle_sapling": "dzsungelfacsemete",
  "block.minecraft.acacia_sapling": "akáciacsemete",
  "block.minecraft.dark_oak_sapling": "sötéttölgy-csemete",
  "block.minecraft.bedrock": "alapkő",
  "block.minecraft.sand": "homok",
  "block.minecraft.red_sand": "vörös homok",
  "block.minecraft.gravel": "sóder",
  "block.minecraft.gold_ore": "aranyérc",
  "block.minecraft.iron_ore": "vasérc",
  "block.minecraft.coal_ore": "szénérc",
  "block.minecraft.nether_gold_ore": "netheraranyérc",
  "block.minecraft.oak_log": "tölgyfarönk",
  "block.minecraft.spruce_log": "fenyőrönk",
  "block.minecraft.birch_log": "nyírfarönk",
  "block.minecraft.jungle_log": "dzsungelfarönk",
  "block.minecraft.acacia_log": "akáciarönk",
  "block.minecraft.dark_oak_log": "sötéttölgy-rönk",
  "block.minecraft.crimson_stem": "karmazsin tönk",
  "block.minecraft.warped_stem": "torz tönk",
  "block.minecraft.stripped_oak_log": "kérgezett tölgyfarönk",
  "block.minecraft.stripped_spruce_log": "kérgezett fenyőrönk",
  "block.minecraft.stripped_birch_log": "kérgezett nyírfarönk",
  "block.minecraft.stripped_jungle_log": "kérgezett dzsungelfarönk",
  "block.minecraft.stripped_acacia_log": "kérgezett akáciarönk",
  "block.minecraft.stripped_dark_oak_log": "kérgezett sötéttölgy-rönk",
  "block.minecraft.stripped_crimson_stem": "kérgezett karmazsin tönk",
  "block.minecraft.stripped_warped_stem": "kérgezett torz tönk",
  "block.minecraft.stripped_oak_wood": "kérgezett tölgyfablokk",
  "block.minecraft.stripped_spruce_wood": "kérgezett fenyőblokk",
  "block.minecraft.stripped_birch_wood": "kérgezett nyírfablokk",
  "block.minecraft.stripped_jungle_wood": "kérgezett dzsungelfablokk",
  "block.minecraft.stripped_acacia_wood": "kérgezett akáciablokk",
  "block.minecraft.stripped_dark_oak_wood": "kérgezett sötéttölgyblokk",
  "block.minecraft.stripped_crimson_hyphae": "kérgezett karmazsin gombafonalak",
  "block.minecraft.stripped_warped_hyphae": "kérgezett torz gombafonalak",
  "block.minecraft.oak_wood": "tölgyfablokk",
  "block.minecraft.spruce_wood": "fenyőblokk",
  "block.minecraft.birch_wood": "nyírfablokk",
  "block.minecraft.jungle_wood": "dzsungelfablokk",
  "block.minecraft.acacia_wood": "akáciablokk",
  "block.minecraft.dark_oak_wood": "sötéttölgyblokk",
  "block.minecraft.crimson_hyphae": "karmazsin gombafonalak",
  "block.minecraft.warped_hyphae": "torz gombafonalak",
  "block.minecraft.oak_leaves": "tölgylevelek",
  "block.minecraft.spruce_leaves": "fenyőlevelek",
  "block.minecraft.birch_leaves": "nyírfalevelek",
  "block.minecraft.jungle_leaves": "dzsungelfalevelek",
  "block.minecraft.acacia_leaves": "akácialevelek",
  "block.minecraft.dark_oak_leaves": "sötéttölgy-levelek",
  "block.minecraft.sponge": "szivacs",
  "block.minecraft.wet_sponge": "nedves szivacs",
  "block.minecraft.glass": "üveg",
  "block.minecraft.lapis_ore": "lazuritérc",
  "block.minecraft.lapis_block": "lazuritblokk",
  "block.minecraft.dispenser": "adagoló",
  "block.minecraft.sandstone": "homokkő",
  "block.minecraft.chiseled_sandstone": "vésett homokkő",
  "block.minecraft.cut_sandstone": "vágott homokkő",
  "block.minecraft.note_block": "hangdoboz",
  "block.minecraft.powered_rail": "gyorsítósín",
  "block.minecraft.detector_rail": "érzékelősín",
  "block.minecraft.sticky_piston": "ragacsos dugattyú",
  "block.minecraft.cobweb": "pókháló",
  "block.minecraft.grass": "fű",
  "block.minecraft.fern": "páfrány",
  "block.minecraft.dead_bush": "száraz kóró",
  "block.minecraft.seagrass": "tengerifű",
  "block.minecraft.sea_pickle": "világító zsákállat",
  "block.minecraft.piston": "dugattyú",
  "block.minecraft.white_wool": "fehér gyapjú",
  "block.minecraft.orange_wool": "narancssárga gyapjú",
  "block.minecraft.magenta_wool": "bíbor gyapjú",
  "block.minecraft.light_blue_wool": "világoskék gyapjú",
  "block.minecraft.yellow_wool": "sárga gyapjú",
  "block.minecraft.lime_wool": "világoszöld gyapjú",
  "block.minecraft.pink_wool": "rózsaszín gyapjú",
  "block.minecraft.gray_wool": "szürke gyapjú",
  "block.minecraft.light_gray_wool": "világosszürke gyapjú",
  "block.minecraft.cyan_wool": "türkizkék gyapjú",
  "block.minecraft.purple_wool": "lila gyapjú",
  "block.minecraft.blue_wool": "kék gyapjú",
  "block.minecraft.brown_wool": "barna gyapjú",
  "block.minecraft.green_wool": "zöld gyapjú",
  "block.minecraft.red_wool": "vörös gyapjú",
  "block.minecraft.black_wool": "fekete gyapjú",
  "block.minecraft.dandelion": "pitypang",
  "block.minecraft.poppy": "pipacs",
  "block.minecraft.blue_orchid": "kék orchidea",
  "block.minecraft.allium": "hagymavirág",
  "block.minecraft.azure_bluet": "kékpárna",
  "block.minecraft.red_tulip": "piros tulipán",
  "block.minecraft.orange_tulip": "narancssárga tulipán",
  "block.minecraft.white_tulip": "fehér tulipán",
  "block.minecraft.pink_tulip": "rózsaszín tulipán",
  "block.minecraft.oxeye_daisy": "margaréta",
  "block.minecraft.cornflower": "búzavirág",
  "block.minecraft.lily_of_the_valley": "gyöngyvirág",
  "block.minecraft.wither_rose": "witherrózsa",
  "block.minecraft.brown_mushroom": "barna gomba",
  "block.minecraft.red_mushroom": "piros gomba",
  "block.minecraft.crimson_fungus": "karmazsin gomba",
  "block.minecraft.warped_fungus": "torz gomba",
  "block.minecraft.crimson_roots": "karmazsin gyökerek",
  "block.minecraft.warped_roots": "torz gyökerek",
  "block.minecraft.nether_sprouts": "nethercsírák",
  "block.minecraft.weeping_vines": "keserves indák",
  "block.minecraft.twisting_vines": "tekergő indák",
  "block.minecraft.sugar_cane": "cukornád",
  "block.minecraft.kelp": "hínár",
  "block.minecraft.bamboo": "bambusz",
  "block.minecraft.gold_block": "aranyblokk",
  "block.minecraft.iron_block": "vasblokk",
  "block.minecraft.oak_slab": "tölgyfa lap",
  "block.minecraft.spruce_slab": "fenyőfa lap",
  "block.minecraft.birch_slab": "nyírfa lap",
  "block.minecraft.jungle_slab": "dzsungelfa lap",
  "block.minecraft.acacia_slab": "akáciafa lap",
  "block.minecraft.dark_oak_slab": "sötéttölgy lap",
  "block.minecraft.crimson_slab": "karmazsin deszkalap",
  "block.minecraft.warped_slab": "torz deszkalap",
  "block.minecraft.stone_slab": "kőlap",
  "block.minecraft.smooth_stone_slab": "csiszolt kőlap",
  "block.minecraft.sandstone_slab": "homokkő lap",
  "block.minecraft.cut_sandstone_slab": "vágott homokkő lap",
  "block.minecraft.petrified_oak_slab": "megkövült tölgyfa lap",
  "block.minecraft.cobblestone_slab": "zúzottkő lap",
  "block.minecraft.brick_slab": "tégla-lap",
  "block.minecraft.stone_brick_slab": "kőtégla lap",
  "block.minecraft.nether_brick_slab": "nethertégla lap",
  "block.minecraft.quartz_slab": "kvarclap",
  "block.minecraft.red_sandstone_slab": "vörös homokkő lap",
  "block.minecraft.cut_red_sandstone_slab": "vágott vörös homokkő lap",
  "block.minecraft.purpur_slab": "purpurlap",
  "block.minecraft.prismarine_slab": "prizmarinlap",
  "block.minecraft.prismarine_brick_slab": "prizmarintégla lap",
  "block.minecraft.dark_prismarine_slab": "sötét prizmarinlap",
  "block.minecraft.smooth_quartz": "csiszolt kvarcblokk",
  "block.minecraft.smooth_red_sandstone": "csiszolt vörös homokkő",
  "block.minecraft.smooth_sandstone": "csiszolt homokkő",
  "block.minecraft.smooth_stone": "csiszolt kő",
  "block.minecraft.bricks": "tégla",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "könyvespolc",
  "block.minecraft.mossy_cobblestone": "mohás zúzottkő",
  "block.minecraft.obsidian": "obszidián",
  "block.minecraft.torch": "fáklya",
  "block.minecraft.end_rod": "end-rúd",
  "block.minecraft.chorus_plant": "refrénnövény",
  "block.minecraft.chorus_flower": "refrénvirág",
  "block.minecraft.purpur_block": "purpurblokk",
  "block.minecraft.purpur_pillar": "purpuroszlop",
  "block.minecraft.purpur_stairs": "purpurlépcső",
  "block.minecraft.spawner": "idézőketrec",
  "block.minecraft.oak_stairs": "tölgyfa lépcső",
  "block.minecraft.chest": "láda",
  "block.minecraft.diamond_ore": "gyémántérc",
  "block.minecraft.diamond_block": "gyémántblokk",
  "block.minecraft.crafting_table": "barkácsasztal",
  "block.minecraft.farmland": "termőföld",
  "block.minecraft.furnace": "kemence",
  "block.minecraft.ladder": "létra",
  "block.minecraft.rail": "sín",
  "block.minecraft.cobblestone_stairs": "zúzottkő lépcső",
  "block.minecraft.lever": "kar",
  "block.minecraft.stone_pressure_plate": "kő nyomólap",
  "block.minecraft.oak_pressure_plate": "tölgyfa nyomólap",
  "block.minecraft.spruce_pressure_plate": "fenyőfa nyomólap",
  "block.minecraft.birch_pressure_plate": "nyírfa nyomólap",
  "block.minecraft.jungle_pressure_plate": "dzsungelfa nyomólap",
  "block.minecraft.acacia_pressure_plate": "akáciafa nyomólap",
  "block.minecraft.dark_oak_pressure_plate": "sötéttölgy nyomólap",
  "block.minecraft.crimson_pressure_plate": "karmazsin nyomólap",
  "block.minecraft.warped_pressure_plate": "torz nyomólap",
  "block.minecraft.polished_blackstone_pressure_plate": "csiszolt feketekő nyomólap",
  "block.minecraft.redstone_ore": "redstone-érc",
  "block.minecraft.redstone_torch": "redstone-fáklya",
  "block.minecraft.snow": "hó",
  "block.minecraft.ice": "jég",
  "block.minecraft.snow_block": "hóblokk",
  "block.minecraft.cactus": "kaktusz",
  "block.minecraft.clay": "agyag",
  "block.minecraft.jukebox": "zenegép",
  "block.minecraft.oak_fence": "tölgyfa kerítés",
  "block.minecraft.spruce_fence": "fenyőfa kerítés",
  "block.minecraft.birch_fence": "nyírfa kerítés",
  "block.minecraft.jungle_fence": "dzsungelfa kerítés",
  "block.minecraft.acacia_fence": "akáciafa kerítés",
  "block.minecraft.dark_oak_fence": "sötéttölgy kerítés",
  "block.minecraft.crimson_fence": "karmazsin kerítés",
  "block.minecraft.warped_fence": "torz kerítés",
  "block.minecraft.pumpkin": "tök",
  "block.minecraft.carved_pumpkin": "faragott tök",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "lélekhomok",
  "block.minecraft.soul_soil": "lélektalaj",
  "block.minecraft.basalt": "bazalt",
  "block.minecraft.polished_basalt": "csiszolt bazalt",
  "block.minecraft.soul_torch": "lélekfáklya",
  "block.minecraft.glowstone": "izzókő",
  "block.minecraft.jack_o_lantern": "töklámpás",
  "block.minecraft.oak_trapdoor": "tölgyfa csapóajtó",
  "block.minecraft.spruce_trapdoor": "fenyőfa csapóajtó",
  "block.minecraft.birch_trapdoor": "nyírfa csapóajtó",
  "block.minecraft.jungle_trapdoor": "dzsungelfa csapóajtó",
  "block.minecraft.acacia_trapdoor": "akáciafa csapóajtó",
  "block.minecraft.dark_oak_trapdoor": "sötéttölgy csapóajtó",
  "block.minecraft.crimson_trapdoor": "karmazsin csapóajtó",
  "block.minecraft.warped_trapdoor": "torz csapóajtó",
  "block.minecraft.infested_stone": "kő ezüstmollyal",
  "block.minecraft.infested_cobblestone": "zúzottkő ezüstmollyal",
  "block.minecraft.infested_stone_bricks": "kőtégla ezüstmollyal",
  "block.minecraft.infested_mossy_stone_bricks": "mohás kőtégla ezüstmollyal",
  "block.minecraft.infested_cracked_stone_bricks": "repedt kőtégla ezüstmollyal",
  "block.minecraft.infested_chiseled_stone_bricks": "vésett kőtégla ezüstmollyal",
  "block.minecraft.stone_bricks": "kőtégla",
  "block.minecraft.mossy_stone_bricks": "mohás kőtégla",
  "block.minecraft.cracked_stone_bricks": "repedezett kőtégla",
  "block.minecraft.chiseled_stone_bricks": "vésett kőtégla",
  "block.minecraft.brown_mushroom_block": "barna gombablokk",
  "block.minecraft.red_mushroom_block": "piros gombablokk",
  "block.minecraft.mushroom_stem": "gombatönk",
  "block.minecraft.iron_bars": "vasrács",
  "block.minecraft.chain": "lánc",
  "block.minecraft.glass_pane": "üveglap",
  "block.minecraft.melon": "dinnye",
  "block.minecraft.vine": "inda",
  "block.minecraft.oak_fence_gate": "tölgyfa kerítéskapu",
  "block.minecraft.spruce_fence_gate": "fenyőfa kerítéskapu",
  "block.minecraft.birch_fence_gate": "nyírfa kerítéskapu",
  "block.minecraft.jungle_fence_gate": "dzsungelfa kerítéskapu",
  "block.minecraft.acacia_fence_gate": "akáciafa kerítéskapu",
  "block.minecraft.dark_oak_fence_gate": "sötéttölgy kerítéskapu",
  "block.minecraft.crimson_fence_gate": "karmazsin kerítéskapu",
  "block.minecraft.warped_fence_gate": "torz kerítéskapu",
  "block.minecraft.brick_stairs": "téglalépcső",
  "block.minecraft.stone_brick_stairs": "kőtégla-lépcső",
  "block.minecraft.mycelium": "micélium",
  "block.minecraft.lily_pad": "tavirózsa",
  "block.minecraft.nether_bricks": "nethertégla",
  "block.minecraft.cracked_nether_bricks": "repedt nethertégla",
  "block.minecraft.chiseled_nether_bricks": "vésett nethertégla",
  "block.minecraft.nether_brick_fence": "nethertégla-kerítés",
  "block.minecraft.nether_brick_stairs": "nethertégla-lépcső",
  "block.minecraft.enchanting_table": "varázslóasztal",
  "block.minecraft.end_portal_frame": "endportál-keret",
  "block.minecraft.end_stone": "endkő",
  "block.minecraft.end_stone_bricks": "endkőtégla",
  "block.minecraft.dragon_egg": "sárkánytojás",
  "block.minecraft.redstone_lamp": "redstone-lámpa",
  "block.minecraft.sandstone_stairs": "homokkő lépcső",
  "block.minecraft.emerald_ore": "smaragdérc",
  "block.minecraft.ender_chest": "enderláda",
  "block.minecraft.tripwire_hook": "botlódrót-horog",
  "block.minecraft.emerald_block": "smaragdblokk",
  "block.minecraft.spruce_stairs": "fenyőfa lépcső",
  "block.minecraft.birch_stairs": "nyírfa lépcső",
  "block.minecraft.jungle_stairs": "dzsungelfa lépcső",
  "block.minecraft.crimson_stairs": "karmazsin lépcső",
  "block.minecraft.warped_stairs": "torz lépcső",
  "block.minecraft.command_block": "parancsblokk",
  "block.minecraft.beacon": "jelzőfény",
  "block.minecraft.cobblestone_wall": "zúzottkő-fal",
  "block.minecraft.mossy_cobblestone_wall": "mohás zúzottkő-fal",
  "block.minecraft.brick_wall": "téglafal",
  "block.minecraft.prismarine_wall": "prizmarinfal",
  "block.minecraft.red_sandstone_wall": "vörös homokkő fal",
  "block.minecraft.mossy_stone_brick_wall": "mohás kőtéglafal",
  "block.minecraft.granite_wall": "gránitfal",
  "block.minecraft.stone_brick_wall": "kőtéglafal",
  "block.minecraft.nether_brick_wall": "nethertégla-fal",
  "block.minecraft.andesite_wall": "andezitfal",
  "block.minecraft.red_nether_brick_wall": "vörös nethertégla-fal",
  "block.minecraft.sandstone_wall": "homokkő fal",
  "block.minecraft.end_stone_brick_wall": "endkőtégla-fal",
  "block.minecraft.diorite_wall": "dioritfal",
  "block.minecraft.blackstone_wall": "feketekő fal",
  "block.minecraft.polished_blackstone_wall": "csiszolt feketekő fal",
  "block.minecraft.polished_blackstone_brick_wall": "csiszolt feketekőtégla-fal",
  "block.minecraft.stone_button": "kőgomb",
  "block.minecraft.oak_button": "tölgyfa gomb",
  "block.minecraft.spruce_button": "fenyőfa gomb",
  "block.minecraft.birch_button": "nyírfa gomb",
  "block.minecraft.jungle_button": "dzsungelfa gomb",
  "block.minecraft.acacia_button": "akáciafa gomb",
  "block.minecraft.dark_oak_button": "sötéttölgy gomb",
  "block.minecraft.crimson_button": "karmazsin gomb",
  "block.minecraft.warped_button": "torz gomb",
  "block.minecraft.polished_blackstone_button": "csiszolt feketekő gomb",
  "block.minecraft.anvil": "üllő",
  "block.minecraft.chipped_anvil": "repedt üllő",
  "block.minecraft.damaged_anvil": "sérült üllő",
  "block.minecraft.trapped_chest": "csapdaláda",
  "block.minecraft.light_weighted_pressure_plate": "könnyű súlymérő nyomólap",
  "block.minecraft.heavy_weighted_pressure_plate": "nehéz súlymérő nyomólap",
  "block.minecraft.daylight_detector": "napfényérzékelő",
  "block.minecraft.redstone_block": "redstone-blokk",
  "block.minecraft.nether_quartz_ore": "netherkvarcérc",
  "block.minecraft.hopper": "tölcsér",
  "block.minecraft.chiseled_quartz_block": "vésett kvarcblokk",
  "block.minecraft.quartz_block": "kvarcblokk",
  "block.minecraft.quartz_bricks": "kvarctégla",
  "block.minecraft.quartz_pillar": "kvarcoszlop",
  "block.minecraft.quartz_stairs": "kvarclépcső",
  "block.minecraft.activator_rail": "aktiválósín",
  "block.minecraft.dropper": "kidobó",
  "block.minecraft.white_terracotta": "fehér terrakotta",
  "block.minecraft.orange_terracotta": "narancssárga terrakotta",
  "block.minecraft.magenta_terracotta": "bíbor terrakotta",
  "block.minecraft.light_blue_terracotta": "világoskék terrakotta",
  "block.minecraft.yellow_terracotta": "sárga terrakotta",
  "block.minecraft.lime_terracotta": "világoszöld terrakotta",
  "block.minecraft.pink_terracotta": "rózsaszín terrakotta",
  "block.minecraft.gray_terracotta": "szürke terrakotta",
  "block.minecraft.light_gray_terracotta": "világosszürke terrakotta",
  "block.minecraft.cyan_terracotta": "türkizkék terrakotta",
  "block.minecraft.purple_terracotta": "lila terrakotta",
  "block.minecraft.blue_terracotta": "kék terrakotta",
  "block.minecraft.brown_terracotta": "barna terrakotta",
  "block.minecraft.green_terracotta": "zöld terrakotta",
  "block.minecraft.red_terracotta": "vörös terrakotta",
  "block.minecraft.black_terracotta": "fekete terrakotta",
  "block.minecraft.barrier": "akadály",
  "block.minecraft.iron_trapdoor": "vas csapóajtó",
  "block.minecraft.hay_block": "szalmabála",
  "block.minecraft.white_carpet": "fehér szőnyeg",
  "block.minecraft.orange_carpet": "narancssárga szőnyeg",
  "block.minecraft.magenta_carpet": "bíbor szőnyeg",
  "block.minecraft.light_blue_carpet": "világoskék szőnyeg",
  "block.minecraft.yellow_carpet": "sárga szőnyeg",
  "block.minecraft.lime_carpet": "világoszöld szőnyeg",
  "block.minecraft.pink_carpet": "rózsaszín szőnyeg",
  "block.minecraft.gray_carpet": "szürke szőnyeg",
  "block.minecraft.light_gray_carpet": "világosszürke szőnyeg",
  "block.minecraft.cyan_carpet": "türkizkék szőnyeg",
  "block.minecraft.purple_carpet": "lila szőnyeg",
  "block.minecraft.blue_carpet": "kék szőnyeg",
  "block.minecraft.brown_carpet": "barna szőnyeg",
  "block.minecraft.green_carpet": "zöld szőnyeg",
  "block.minecraft.red_carpet": "vörös szőnyeg",
  "block.minecraft.black_carpet": "fekete szőnyeg",
  "block.minecraft.terracotta": "terrakotta",
  "block.minecraft.coal_block": "szénblokk",
  "block.minecraft.packed_ice": "tömör jég",
  "block.minecraft.acacia_stairs": "akáciafa lépcső",
  "block.minecraft.dark_oak_stairs": "sötéttölgy lépcső",
  "block.minecraft.slime_block": "nyálkablokk",
  "block.minecraft.grass_path": "ösvény",
  "block.minecraft.sunflower": "napraforgó",
  "block.minecraft.lilac": "orgona",
  "block.minecraft.rose_bush": "rózsabokor",
  "block.minecraft.peony": "bazsarózsa",
  "block.minecraft.tall_grass": "magas fű",
  "block.minecraft.large_fern": "nagy páfrány",
  "block.minecraft.white_stained_glass": "fehér festett üveg",
  "block.minecraft.orange_stained_glass": "narancssárga festett üveg",
  "block.minecraft.magenta_stained_glass": "bíbor festett üveg",
  "block.minecraft.light_blue_stained_glass": "világoskék festett üveg",
  "block.minecraft.yellow_stained_glass": "sárga festett üveg",
  "block.minecraft.lime_stained_glass": "világoszöld festett üveg",
  "block.minecraft.pink_stained_glass": "rózsaszín festett üveg",
  "block.minecraft.gray_stained_glass": "szürke festett üveg",
  "block.minecraft.light_gray_stained_glass": "világosszürke festett üveg",
  "block.minecraft.cyan_stained_glass": "türkizkék festett üveg",
  "block.minecraft.purple_stained_glass": "lila festett üveg",
  "block.minecraft.blue_stained_glass": "kék festett üveg",
  "block.minecraft.brown_stained_glass": "barna festett üveg",
  "block.minecraft.green_stained_glass": "zöld festett üveg",
  "block.minecraft.red_stained_glass": "vörös festett üveg",
  "block.minecraft.black_stained_glass": "fekete festett üveg",
  "block.minecraft.white_stained_glass_pane": "fehér festett üveglap",
  "block.minecraft.orange_stained_glass_pane": "narancssárga festett üveglap",
  "block.minecraft.magenta_stained_glass_pane": "bíbor festett üveglap",
  "block.minecraft.light_blue_stained_glass_pane": "világoskék festett üveglap",
  "block.minecraft.yellow_stained_glass_pane": "sárga festett üveglap",
  "block.minecraft.lime_stained_glass_pane": "világoszöld festett üveglap",
  "block.minecraft.pink_stained_glass_pane": "rózsaszín festett üveglap",
  "block.minecraft.gray_stained_glass_pane": "szürke festett üveglap",
  "block.minecraft.light_gray_stained_glass_pane": "világosszürke festett üveglap",
  "block.minecraft.cyan_stained_glass_pane": "türkizkék festett üveglap",
  "block.minecraft.purple_stained_glass_pane": "lila festett üveglap",
  "block.minecraft.blue_stained_glass_pane": "kék festett üveglap",
  "block.minecraft.brown_stained_glass_pane": "barna festett üveglap",
  "block.minecraft.green_stained_glass_pane": "zöld festett üveglap",
  "block.minecraft.red_stained_glass_pane": "vörös festett üveglap",
  "block.minecraft.black_stained_glass_pane": "fekete festett üveglap",
  "block.minecraft.prismarine": "prizmarin",
  "block.minecraft.prismarine_bricks": "prizmarintégla",
  "block.minecraft.dark_prismarine": "sötét prizmarin",
  "block.minecraft.prismarine_stairs": "prizmarinlépcső",
  "block.minecraft.prismarine_brick_stairs": "prizmarintégla lépcső",
  "block.minecraft.dark_prismarine_stairs": "sötét prizmarinlépcső",
  "block.minecraft.sea_lantern": "tengeri lámpás",
  "block.minecraft.red_sandstone": "vörös homokkő",
  "block.minecraft.chiseled_red_sandstone": "vésett vörös homokkő",
  "block.minecraft.cut_red_sandstone": "vágott vörös homokkő",
  "block.minecraft.red_sandstone_stairs": "vörös homokkő lépcső",
  "block.minecraft.repeating_command_block": "ismétlő parancsblokk",
  "block.minecraft.chain_command_block": "láncolt parancsblokk",
  "block.minecraft.magma_block": "magmablokk",
  "block.minecraft.nether_wart_block": "netherbibircsók-blokk",
  "block.minecraft.warped_wart_block": "torz bibircsókblokk",
  "block.minecraft.red_nether_bricks": "vörös nethertégla",
  "block.minecraft.bone_block": "csontblokk",
  "block.minecraft.structure_void": "struktúraűr",
  "block.minecraft.observer": "megfigyelő",
  "block.minecraft.shulker_box": "shulkerdoboz",
  "block.minecraft.white_shulker_box": "fehér shulkerdoboz",
  "block.minecraft.orange_shulker_box": "narancssárga shulkerdoboz",
  "block.minecraft.magenta_shulker_box": "bíbor shulkerdoboz",
  "block.minecraft.light_blue_shulker_box": "világoskék shulkerdoboz",
  "block.minecraft.yellow_shulker_box": "sárga shulkerdoboz",
  "block.minecraft.lime_shulker_box": "világoszöld shulkerdoboz",
  "block.minecraft.pink_shulker_box": "rózsaszín shulkerdoboz",
  "block.minecraft.gray_shulker_box": "szürke shulkerdoboz",
  "block.minecraft.light_gray_shulker_box": "világosszürke shulkerdoboz",
  "block.minecraft.cyan_shulker_box": "türkizkék shulkerdoboz",
  "block.minecraft.purple_shulker_box": "lila shulkerdoboz",
  "block.minecraft.blue_shulker_box": "kék shulkerdoboz",
  "block.minecraft.brown_shulker_box": "barna shulkerdoboz",
  "block.minecraft.green_shulker_box": "zöld shulkerdoboz",
  "block.minecraft.red_shulker_box": "vörös shulkerdoboz",
  "block.minecraft.black_shulker_box": "fekete shulkerdoboz",
  "block.minecraft.white_glazed_terracotta": "fehér mázas kerámia",
  "block.minecraft.orange_glazed_terracotta": "narancssárga mázas kerámia",
  "block.minecraft.magenta_glazed_terracotta": "bíbor mázas kerámia",
  "block.minecraft.light_blue_glazed_terracotta": "világoskék mázas kerámia",
  "block.minecraft.yellow_glazed_terracotta": "sárga mázas kerámia",
  "block.minecraft.lime_glazed_terracotta": "világoszöld mázas kerámia",
  "block.minecraft.pink_glazed_terracotta": "rózsaszín mázas kerámia",
  "block.minecraft.gray_glazed_terracotta": "szürke mázas kerámia",
  "block.minecraft.light_gray_glazed_terracotta": "világosszürke mázas kerámia",
  "block.minecraft.cyan_glazed_terracotta": "türkizkék mázas kerámia",
  "block.minecraft.purple_glazed_terracotta": "lila mázas kerámia",
  "block.minecraft.blue_glazed_terracotta": "kék mázas kerámia",
  "block.minecraft.brown_glazed_terracotta": "barna mázas kerámia",
  "block.minecraft.green_glazed_terracotta": "zöld mázas kerámia",
  "block.minecraft.red_glazed_terracotta": "vörös mázas kerámia",
  "block.minecraft.black_glazed_terracotta": "fekete mázas kerámia",
  "block.minecraft.white_concrete": "fehér beton",
  "block.minecraft.orange_concrete": "narancssárga beton",
  "block.minecraft.magenta_concrete": "bíbor beton",
  "block.minecraft.light_blue_concrete": "világoskék beton",
  "block.minecraft.yellow_concrete": "sárga beton",
  "block.minecraft.lime_concrete": "világoszöld beton",
  "block.minecraft.pink_concrete": "rózsaszín beton",
  "block.minecraft.gray_concrete": "szürke beton",
  "block.minecraft.light_gray_concrete": "világosszürke beton",
  "block.minecraft.cyan_concrete": "türkizkék beton",
  "block.minecraft.purple_concrete": "lila beton",
  "block.minecraft.blue_concrete": "kék beton",
  "block.minecraft.brown_concrete": "barna beton",
  "block.minecraft.green_concrete": "zöld beton",
  "block.minecraft.red_concrete": "vörös beton",
  "block.minecraft.black_concrete": "fekete beton",
  "block.minecraft.white_concrete_powder": "fehér szárazbeton",
  "block.minecraft.orange_concrete_powder": "narancssárga szárazbeton",
  "block.minecraft.magenta_concrete_powder": "bíbor szárazbeton",
  "block.minecraft.light_blue_concrete_powder": "világoskék szárazbeton",
  "block.minecraft.yellow_concrete_powder": "sárga szárazbeton",
  "block.minecraft.lime_concrete_powder": "világoszöld szárazbeton",
  "block.minecraft.pink_concrete_powder": "rózsaszín szárazbeton",
  "block.minecraft.gray_concrete_powder": "szürke szárazbeton",
  "block.minecraft.light_gray_concrete_powder": "világosszürke szárazbeton",
  "block.minecraft.cyan_concrete_powder": "türkizkék szárazbeton",
  "block.minecraft.purple_concrete_powder": "lila szárazbeton",
  "block.minecraft.blue_concrete_powder": "kék szárazbeton",
  "block.minecraft.brown_concrete_powder": "barna szárazbeton",
  "block.minecraft.green_concrete_powder": "zöld szárazbeton",
  "block.minecraft.red_concrete_powder": "vörös szárazbeton",
  "block.minecraft.black_concrete_powder": "fekete szárazbeton",
  "block.minecraft.turtle_egg": "teknőstojás",
  "block.minecraft.dead_tube_coral_block": "elhalt csőkorall-blokk",
  "block.minecraft.dead_brain_coral_block": "elhalt agykorall-blokk",
  "block.minecraft.dead_bubble_coral_block": "elhalt buborékkorall-blokk",
  "block.minecraft.dead_fire_coral_block": "elhalt tűzkorall-blokk",
  "block.minecraft.dead_horn_coral_block": "elhalt agancskorall-blokk",
  "block.minecraft.tube_coral_block": "csőkorall-blokk",
  "block.minecraft.brain_coral_block": "agykorall-blokk",
  "block.minecraft.bubble_coral_block": "buborékkorall-blokk",
  "block.minecraft.fire_coral_block": "tűzkorall-blokk",
  "block.minecraft.horn_coral_block": "agancskorall-blokk",
  "block.minecraft.tube_coral": "csőkorall",
  "block.minecraft.brain_coral": "agykorall",
  "block.minecraft.bubble_coral": "buborékkorall",
  "block.minecraft.fire_coral": "tűzkorall",
  "block.minecraft.horn_coral": "agancskorall",
  "block.minecraft.dead_brain_coral": "elhalt agykorall",
  "block.minecraft.dead_bubble_coral": "elhalt buborékkorall",
  "block.minecraft.dead_fire_coral": "elhalt tűzkorall",
  "block.minecraft.dead_horn_coral": "elhalt agancskorall",
  "block.minecraft.dead_tube_coral": "elhalt csőkorall",
  "block.minecraft.tube_coral_fan": "csőkorall-legyező",
  "block.minecraft.brain_coral_fan": "agykorall-legyező",
  "block.minecraft.bubble_coral_fan": "buborékkorall-legyező",
  "block.minecraft.fire_coral_fan": "tűzkorall-legyező",
  "block.minecraft.horn_coral_fan": "agancskorall-legyező",
  "block.minecraft.dead_tube_coral_fan": "elhalt csőkorall-legyező",
  "block.minecraft.dead_brain_coral_fan": "elhalt agykorall-legyező",
  "block.minecraft.dead_bubble_coral_fan": "elhalt buborékkorall-legyező",
  "block.minecraft.dead_fire_coral_fan": "elhalt tűzkorall-legyező",
  "block.minecraft.dead_horn_coral_fan": "elhalt agancskorall-legyező",
  "block.minecraft.blue_ice": "kék jég",
  "block.minecraft.conduit": "csatorna",
  "block.minecraft.polished_granite_stairs": "csiszolt gránitlépcső",
  "block.minecraft.smooth_red_sandstone_stairs": "csiszolt vörös homokkő lépcső",
  "block.minecraft.mossy_stone_brick_stairs": "mohás kőtégla-lépcső",
  "block.minecraft.polished_diorite_stairs": "csiszolt dioritlépcső",
  "block.minecraft.mossy_cobblestone_stairs": "mohás zúzottkőlépcső",
  "block.minecraft.end_stone_brick_stairs": "endkőtégla-lépcső",
  "block.minecraft.stone_stairs": "kőlépcső",
  "block.minecraft.smooth_sandstone_stairs": "csiszolt homokkő lépcső",
  "block.minecraft.smooth_quartz_stairs": "csiszolt kvarclépcső",
  "block.minecraft.granite_stairs": "gránitlépcső",
  "block.minecraft.andesite_stairs": "andezitlépcső",
  "block.minecraft.red_nether_brick_stairs": "vörös nethertégla-lépcső",
  "block.minecraft.polished_andesite_stairs": "csiszolt andezitlépcső",
  "block.minecraft.diorite_stairs": "dioritlépcső",
  "block.minecraft.polished_granite_slab": "csiszolt gránitlap",
  "block.minecraft.smooth_red_sandstone_slab": "csiszolt vörös homokkő lap",
  "block.minecraft.mossy_stone_brick_slab": "mohás kőtégla lap",
  "block.minecraft.polished_diorite_slab": "csiszolt dioritlap",
  "block.minecraft.mossy_cobblestone_slab": "mohás zúzottkő lap",
  "block.minecraft.end_stone_brick_slab": "endkőtégla lap",
  "block.minecraft.smooth_sandstone_slab": "csiszolt homokkő lap",
  "block.minecraft.smooth_quartz_slab": "csiszolt kvarclap",
  "block.minecraft.granite_slab": "gránitlap",
  "block.minecraft.andesite_slab": "andezitlap",
  "block.minecraft.red_nether_brick_slab": "vörös nethertégla lap",
  "block.minecraft.polished_andesite_slab": "csiszolt andezitlap",
  "block.minecraft.diorite_slab": "dioritlap",
  "block.minecraft.scaffolding": "állványzat",
  "block.minecraft.iron_door": "vasajtó",
  "block.minecraft.oak_door": "tölgyfa ajtó",
  "block.minecraft.spruce_door": "fenyőfa ajtó",
  "block.minecraft.birch_door": "nyírfa ajtó",
  "block.minecraft.jungle_door": "dzsungelfa ajtó",
  "block.minecraft.acacia_door": "akáciafa ajtó",
  "block.minecraft.dark_oak_door": "sötéttölgy ajtó",
  "block.minecraft.crimson_door": "karmazsin ajtó",
  "block.minecraft.warped_door": "torz ajtó",
  "block.minecraft.repeater": "redstone-jelismétlő",
  "block.minecraft.comparator": "redstone-komparátor",
  "block.minecraft.structure_block": "struktúrablokk",
  "block.minecraft.jigsaw": "kirakósblokk",
  "item.minecraft.turtle_helmet": "teknőspáncél□□fejen hordva:□+2 vértezet",
  "item.minecraft.scute": "pikkely",
  "item.minecraft.iron_shovel": "vasásó□□domináns kézben tartva:□+3.5 sebzés□-3 támadási sebesség",
  "item.minecraft.iron_pickaxe": "vascsákány□□domináns kézben tartva:□+3 sebzés□-2.8 támadási sebesség",
  "item.minecraft.iron_axe": "vasfejsze□□domináns kézben tartva:□+8 sebzés□-3.1 támadási sebesség",
  "item.minecraft.flint_and_steel": "kovakő és acél",
  "item.minecraft.apple": "alma",
  "item.minecraft.bow": "íj",
  "item.minecraft.arrow": "nyílvessző",
  "item.minecraft.coal": "szén",
  "item.minecraft.charcoal": "faszén",
  "item.minecraft.diamond": "gyémánt",
  "item.minecraft.iron_ingot": "vasrúd",
  "item.minecraft.gold_ingot": "aranyrúd",
  "item.minecraft.netherite_ingot": "netheritrúd",
  "item.minecraft.netherite_scrap": "netheritdarab",
  "item.minecraft.iron_sword": "vaskard□□domináns kézben tartva:□+5 sebzés□-2.4 támadási sebesség",
  "item.minecraft.wooden_sword": "fakard□□domináns kézben tartva:□+3 sebzés□-2.4 támadási sebesség",
  "item.minecraft.wooden_shovel": "faásó□□domináns kézben tartva:□+1.5 sebzés□-3 támadási sebesség",
  "item.minecraft.wooden_pickaxe": "facsákány□□domináns kézben tartva:□+1 sebzés□-2.8 támadási sebesség",
  "item.minecraft.wooden_axe": "fafejsze□□domináns kézben tartva:□+6 sebzés□-3.2 támadási sebesség",
  "item.minecraft.stone_sword": "kőkard□□domináns kézben tartva:□+4 sebzés□-2.4 támadási sebesség",
  "item.minecraft.stone_shovel": "kőásó□□domináns kézben tartva:□+2.5 sebzés□-3 támadási sebesség",
  "item.minecraft.stone_pickaxe": "kőcsákány□□domináns kézben tartva:□+2 sebzés□-2.8 támadási sebesség",
  "item.minecraft.stone_axe": "kőfejsze□□domináns kézben tartva:□+8 sebzés□-3.2 támadási sebesség",
  "item.minecraft.diamond_sword": "gyémántkard□□domináns kézben tartva:□+6 sebzés□-2.4 támadási sebesség",
  "item.minecraft.diamond_shovel": "gyémántásó□□domináns kézben tartva:□+4.5 sebzés□-3 támadási sebesség",
  "item.minecraft.diamond_pickaxe": "gyémántcsákány□□domináns kézben tartva:□+4 sebzés□-2.8 támadási sebesség",
  "item.minecraft.diamond_axe": "gyémántfejsze□□domináns kézben tartva:□+8 sebzés□-3 támadási sebesség",
  "item.minecraft.stick": "bot",
  "item.minecraft.bowl": "tál",
  "item.minecraft.mushroom_stew": "gombaragu",
  "item.minecraft.golden_sword": "aranykard□□domináns kézben tartva:□+3 sebzés□-2.4 támadási sebesség",
  "item.minecraft.golden_shovel": "aranyásó□□domináns kézben tartva:□+1.5 sebzés□-3 támadási sebesség",
  "item.minecraft.golden_pickaxe": "aranycsákány□□domináns kézben tartva:□+1 sebzés□-2.8 támadási sebesség",
  "item.minecraft.golden_axe": "aranyfejsze□□domináns kézben tartva:□+6 sebzés□-3 támadási sebesség",
  "item.minecraft.netherite_sword": "netheritkard□□domináns kézben tartva:□+7 sebzés□-2.4 támadási sebesség",
  "item.minecraft.netherite_shovel": "netheritásó□□domináns kézben tartva:□+5.5 sebzés□-3 támadási sebesség",
  "item.minecraft.netherite_pickaxe": "netheritcsákány□□domináns kézben tartva:□+5 sebzés□-2.8 támadási sebesség",
  "item.minecraft.netherite_axe": "netheritfejsze□□domináns kézben tartva:□+9 sebzés□-3 támadási sebesség",
  "item.minecraft.string": "fonál",
  "item.minecraft.feather": "toll",
  "item.minecraft.gunpowder": "puskapor",
  "item.minecraft.wooden_hoe": "fakapa□□domináns kézben tartva:□-3 támadási sebesség",
  "item.minecraft.stone_hoe": "kőkapa□□domináns kézben tartva:□-2 támadási sebesség",
  "item.minecraft.iron_hoe": "vaskapa□□domináns kézben tartva:□-1 támadási sebesség",
  "item.minecraft.diamond_hoe": "gyémántkapa□□domináns kézben tartva:",
  "item.minecraft.golden_hoe": "aranykapa□□domináns kézben tartva:□-3 támadási sebesség",
  "item.minecraft.netherite_hoe": "netheritkapa□□domináns kézben tartva:",
  "item.minecraft.wheat_seeds": "búzamag",
  "item.minecraft.wheat": "búza",
  "item.minecraft.bread": "kenyér",
  "item.minecraft.leather_helmet": "bőrsisak□□fejen hordva:□+1 vértezet",
  "item.minecraft.leather_chestplate": "bőrzubbony□□testen hordva:□+3 vértezet",
  "item.minecraft.leather_leggings": "bőrnadrág□□lábszáron hordva:□+2 vértezet",
  "item.minecraft.leather_boots": "bőrcsizma□□lábfejen hordva:□+1 vértezet",
  "item.minecraft.chainmail_helmet": "láncsisak□□fejen hordva:□+2 vértezet",
  "item.minecraft.chainmail_chestplate": "láncmellvért□□testen hordva:□+5 vértezet",
  "item.minecraft.chainmail_leggings": "lánc lábszárvédő□□lábszáron hordva:□+4 vértezet",
  "item.minecraft.chainmail_boots": "láncbakancs□□lábfejen hordva:□+1 vértezet",
  "item.minecraft.iron_helmet": "vassisak□□fejen hordva:□+2 vértezet",
  "item.minecraft.iron_chestplate": "vas mellvért□□testen hordva:□+6 vértezet",
  "item.minecraft.iron_leggings": "vas lábszárvédő□□lábszáron hordva:□+5 vértezet",
  "item.minecraft.iron_boots": "vascsizma□□lábfejen hordva:□+2 vértezet",
  "item.minecraft.diamond_helmet": "gyémántsisak□□fejen hordva:□+3 vértezet□+2 páncél-ellenállás",
  "item.minecraft.diamond_chestplate": "gyémánt mellvért□□testen hordva:□+8 vértezet□+2 páncél-ellenállás",
  "item.minecraft.diamond_leggings": "gyémánt lábszárvédő□□lábszáron hordva:□+6 vértezet□+2 páncél-ellenállás",
  "item.minecraft.diamond_boots": "gyémántcsizma□□lábfejen hordva:□+3 vértezet□+2 páncél-ellenállás",
  "item.minecraft.golden_helmet": "aranysisak□□fejen hordva:□+2 vértezet",
  "item.minecraft.golden_chestplate": "arany mellvért□□testen hordva:□+5 vértezet",
  "item.minecraft.golden_leggings": "arany lábszárvédő□□lábszáron hordva:□+3 vértezet",
  "item.minecraft.golden_boots": "aranycsizma□□lábfejen hordva:□+1 vértezet",
  "item.minecraft.netherite_helmet": "netheritsisak□□fejen hordva:□+3 vértezet□+3 páncél-ellenállás□+1 stabilitás",
  "item.minecraft.netherite_chestplate": "netherit mellvért□□testen hordva:□+8 vértezet□+3 páncél-ellenállás□+1 stabilitás",
  "item.minecraft.netherite_leggings": "netherit lábszárvédő□□lábszáron hordva:□+6 vértezet□+3 páncél-ellenállás□+1 stabilitás",
  "item.minecraft.netherite_boots": "netheritcsizma□□lábfejen hordva:□+3 vértezet□+3 páncél-ellenállás□+1 stabilitás",
  "item.minecraft.flint": "kovakő",
  "item.minecraft.porkchop": "nyers disznóhús",
  "item.minecraft.cooked_porkchop": "sült sertésszelet",
  "item.minecraft.painting": "festmény",
  "item.minecraft.golden_apple": "aranyalma",
  "item.minecraft.enchanted_golden_apple": "bűvös aranyalma",
  "block.minecraft.oak_sign": "tölgyfa tábla",
  "block.minecraft.spruce_sign": "fenyőtábla",
  "block.minecraft.birch_sign": "nyírfa tábla",
  "block.minecraft.jungle_sign": "dzsungelfa tábla",
  "block.minecraft.acacia_sign": "akáciafa tábla",
  "block.minecraft.dark_oak_sign": "sötéttölgy tábla",
  "block.minecraft.crimson_sign": "karmazsin tábla",
  "block.minecraft.warped_sign": "torz tábla",
  "item.minecraft.bucket": "vödör",
  "item.minecraft.water_bucket": "vizesvödör",
  "item.minecraft.lava_bucket": "lávásvödör",
  "item.minecraft.minecart": "csille",
  "item.minecraft.saddle": "nyereg",
  "item.minecraft.redstone": "redstone-por",
  "item.minecraft.snowball": "hógolyó",
  "item.minecraft.oak_boat": "tölgyfa csónak",
  "item.minecraft.leather": "bőr",
  "item.minecraft.milk_bucket": "tejesvödör",
  "item.minecraft.pufferfish_bucket": "gömbhal vödörben",
  "item.minecraft.salmon_bucket": "lazac vödörben",
  "item.minecraft.cod_bucket": "tőkehal vödörben",
  "item.minecraft.tropical_fish_bucket": "trópusi hal vödörben",
  "item.minecraft.brick": "tégla",
  "item.minecraft.clay_ball": "agyaggolyó",
  "block.minecraft.dried_kelp_block": "szárított hínárblokk",
  "item.minecraft.paper": "papír",
  "item.minecraft.book": "könyv",
  "item.minecraft.slime_ball": "nyálkagolyó",
  "item.minecraft.chest_minecart": "tárolócsille",
  "item.minecraft.furnace_minecart": "csille kemencével",
  "item.minecraft.egg": "tojás",
  "item.minecraft.compass": "iránytű",
  "item.minecraft.fishing_rod": "horgászbot",
  "item.minecraft.clock": "óra",
  "item.minecraft.glowstone_dust": "izzókőpor",
  "item.minecraft.cod": "nyers tőkehal",
  "item.minecraft.salmon": "nyers lazac",
  "item.minecraft.tropical_fish": "trópusi hal",
  "item.minecraft.pufferfish": "gömbhal",
  "item.minecraft.cooked_cod": "sült tőkehal",
  "item.minecraft.cooked_salmon": "sült lazac",
  "item.minecraft.ink_sac": "tintazsák",
  "item.minecraft.red_dye": "vörös festék",
  "item.minecraft.green_dye": "zöld festék",
  "item.minecraft.cocoa_beans": "kakaóbab",
  "item.minecraft.lapis_lazuli": "lazurit",
  "item.minecraft.purple_dye": "lila festék",
  "item.minecraft.cyan_dye": "türkizkék festék",
  "item.minecraft.light_gray_dye": "világosszürke festék",
  "item.minecraft.gray_dye": "szürke festék",
  "item.minecraft.pink_dye": "rózsaszín festék",
  "item.minecraft.lime_dye": "világoszöld festék",
  "item.minecraft.yellow_dye": "sárga festék",
  "item.minecraft.light_blue_dye": "világoskék festék",
  "item.minecraft.magenta_dye": "bíbor festék",
  "item.minecraft.orange_dye": "narancssárga festék",
  "item.minecraft.bone_meal": "csontliszt",
  "item.minecraft.blue_dye": "kék festék",
  "item.minecraft.brown_dye": "barna festék",
  "item.minecraft.black_dye": "fekete festék",
  "item.minecraft.white_dye": "fehér festék",
  "item.minecraft.bone": "csont",
  "item.minecraft.sugar": "cukor",
  "block.minecraft.cake": "torta",
  "block.minecraft.white_bed": "fehér ágy",
  "block.minecraft.orange_bed": "narancssárga ágy",
  "block.minecraft.magenta_bed": "bíbor ágy",
  "block.minecraft.light_blue_bed": "világoskék ágy",
  "block.minecraft.yellow_bed": "sárga ágy",
  "block.minecraft.lime_bed": "világoszöld ágy",
  "block.minecraft.pink_bed": "rózsaszín ágy",
  "block.minecraft.gray_bed": "szürke ágy",
  "block.minecraft.light_gray_bed": "világosszürke ágy",
  "block.minecraft.cyan_bed": "türkizkék ágy",
  "block.minecraft.purple_bed": "lila ágy",
  "block.minecraft.blue_bed": "kék ágy",
  "block.minecraft.brown_bed": "barna ágy",
  "block.minecraft.green_bed": "zöld ágy",
  "block.minecraft.red_bed": "vörös ágy",
  "block.minecraft.black_bed": "fekete ágy",
  "item.minecraft.cookie": "csokis süti",
  "item.minecraft.filled_map": "térkép□#0",
  "item.minecraft.shears": "metszőolló",
  "item.minecraft.melon_slice": "dinnyeszelet",
  "item.minecraft.dried_kelp": "szárított hínár",
  "item.minecraft.pumpkin_seeds": "tökmag",
  "item.minecraft.melon_seeds": "dinnyemag",
  "item.minecraft.beef": "nyers marhahús",
  "item.minecraft.cooked_beef": "sült marhahús",
  "item.minecraft.chicken": "nyers csirkehús",
  "item.minecraft.cooked_chicken": "sült csirke",
  "item.minecraft.rotten_flesh": "rohadt hús",
  "item.minecraft.ender_pearl": "endergyöngy",
  "item.minecraft.blaze_rod": "lángrúd",
  "item.minecraft.ghast_tear": "ghastkönny",
  "item.minecraft.gold_nugget": "aranyrög",
  "item.minecraft.nether_wart": "netherbibircsók",
  "item.minecraft.potion": "nem főzhető bájital□nincs hatás",
  "item.minecraft.glass_bottle": "üvegpalack",
  "item.minecraft.spider_eye": "pókszem",
  "item.minecraft.fermented_spider_eye": "erjesztett pókszem",
  "item.minecraft.blaze_powder": "őrlángpor",
  "item.minecraft.magma_cream": "magmakrém",
  "block.minecraft.brewing_stand": "főzőállvány",
  "block.minecraft.cauldron": "üst",
  "item.minecraft.ender_eye": "ender szeme",
  "item.minecraft.glistering_melon_slice": "csillámló dinnyeszelet",
  "item.minecraft.bat_spawn_egg": "denevéridéző tojás",
  "item.minecraft.bee_spawn_egg": "méhidéző tojás",
  "item.minecraft.blaze_spawn_egg": "őrlángidéző tojás",
  "item.minecraft.cat_spawn_egg": "macskaidéző tojás",
  "item.minecraft.cave_spider_spawn_egg": "barlangi pókot idéző tojás",
  "item.minecraft.chicken_spawn_egg": "csirkeidéző tojás",
  "item.minecraft.cod_spawn_egg": "tőkehalidéző tojás",
  "item.minecraft.cow_spawn_egg": "tehénidéző tojás",
  "item.minecraft.creeper_spawn_egg": "creeperidéző tojás",
  "item.minecraft.dolphin_spawn_egg": "delfinidéző tojás",
  "item.minecraft.donkey_spawn_egg": "szamáridéző tojás",
  "item.minecraft.drowned_spawn_egg": "vízbefúltidéző tojás",
  "item.minecraft.elder_guardian_spawn_egg": "vén őrszemet idéző tojás",
  "item.minecraft.enderman_spawn_egg": "endermanidéző tojás",
  "item.minecraft.endermite_spawn_egg": "endermite-idéző tojás",
  "item.minecraft.evoker_spawn_egg": "idézőt idéző tojás",
  "item.minecraft.fox_spawn_egg": "rókaidéző tojás",
  "item.minecraft.ghast_spawn_egg": "ghastidéző tojás",
  "item.minecraft.guardian_spawn_egg": "őrszemidéző tojás",
  "item.minecraft.hoglin_spawn_egg": "hoglinidéző tojás",
  "item.minecraft.horse_spawn_egg": "lóidéző tojás",
  "item.minecraft.husk_spawn_egg": "kiszáradt zombit idéző tojás",
  "item.minecraft.llama_spawn_egg": "lámaidéző tojás",
  "item.minecraft.magma_cube_spawn_egg": "magmakocka-idéző tojás",
  "item.minecraft.mooshroom_spawn_egg": "mooshroomidéző tojás",
  "item.minecraft.mule_spawn_egg": "öszvéridéző tojás",
  "item.minecraft.ocelot_spawn_egg": "ocelotidéző tojás",
  "item.minecraft.panda_spawn_egg": "pandaidéző tojás",
  "item.minecraft.parrot_spawn_egg": "papagájidéző tojás",
  "item.minecraft.phantom_spawn_egg": "fantomidéző tojás",
  "item.minecraft.pig_spawn_egg": "malacidéző tojás",
  "item.minecraft.piglin_spawn_egg": "piglinidéző tojás",
  "item.minecraft.pillager_spawn_egg": "rablóidéző tojás",
  "item.minecraft.polar_bear_spawn_egg": "jegesmedve-idéző tojás",
  "item.minecraft.pufferfish_spawn_egg": "gömbhalidéző tojás",
  "item.minecraft.rabbit_spawn_egg": "nyúlidéző tojás",
  "item.minecraft.ravager_spawn_egg": "pusztítóidéző tojás",
  "item.minecraft.salmon_spawn_egg": "lazacidéző tojás",
  "item.minecraft.sheep_spawn_egg": "birkaidéző tojás",
  "item.minecraft.shulker_spawn_egg": "shulkeridéző tojás",
  "item.minecraft.silverfish_spawn_egg": "ezüstmolyidéző tojás",
  "item.minecraft.skeleton_spawn_egg": "csontvázidéző tojás",
  "item.minecraft.skeleton_horse_spawn_egg": "csontvázlóidéző tojás",
  "item.minecraft.slime_spawn_egg": "nyálkaidéző tojás",
  "item.minecraft.spider_spawn_egg": "pókidéző tojás",
  "item.minecraft.squid_spawn_egg": "tintahalidéző tojás",
  "item.minecraft.stray_spawn_egg": "kóborlóidéző tojás",
  "item.minecraft.strider_spawn_egg": "álomfutóidéző tojás",
  "item.minecraft.trader_llama_spawn_egg": "kereskedőláma-idéző tojás",
  "item.minecraft.tropical_fish_spawn_egg": "trópusi halat idéző tojás",
  "item.minecraft.turtle_spawn_egg": "teknősidéző tojás",
  "item.minecraft.vex_spawn_egg": "bosszancsidéző tojás",
  "item.minecraft.villager_spawn_egg": "falusiidéző tojás",
  "item.minecraft.vindicator_spawn_egg": "bosszúálló-idéző tojás",
  "item.minecraft.wandering_trader_spawn_egg": "vándorkereskedő-idéző tojás",
  "item.minecraft.witch_spawn_egg": "boszorkányidéző tojás",
  "item.minecraft.wither_skeleton_spawn_egg": "withercsontváz-idéző tojás",
  "item.minecraft.wolf_spawn_egg": "farkasidéző tojás",
  "item.minecraft.zoglin_spawn_egg": "zoglinidéző tojás",
  "item.minecraft.zombie_spawn_egg": "zombiidéző tojás",
  "item.minecraft.zombie_horse_spawn_egg": "zombilóidéző tojás",
  "item.minecraft.zombie_villager_spawn_egg": "élőhalott falusit idéző tojás",
  "item.minecraft.zombified_piglin_spawn_egg": "élőhalott piglint idéző tojás",
  "item.minecraft.experience_bottle": "varázslat palackja",
  "item.minecraft.fire_charge": "tűzgolyó",
  "item.minecraft.writable_book": "könyv és toll",
  "item.minecraft.written_book": "befejezett könyv",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "eszközkeret",
  "block.minecraft.flower_pot": "virágcserép",
  "item.minecraft.carrot": "sárgarépa",
  "item.minecraft.potato": "burgonya",
  "item.minecraft.baked_potato": "sült burgonya",
  "item.minecraft.poisonous_potato": "mérgező burgonya",
  "item.minecraft.map": "üres térkép",
  "item.minecraft.golden_carrot": "aranyrépa",
  "block.minecraft.skeleton_skull": "csontvázkoponya",
  "block.minecraft.wither_skeleton_skull": "withercsontváz-koponya",
  "block.minecraft.player_head": "játékosfej",
  "block.minecraft.zombie_head": "zombifej",
  "block.minecraft.creeper_head": "creeperfej",
  "block.minecraft.dragon_head": "sárkányfej",
  "item.minecraft.carrot_on_a_stick": "répa horgászboton",
  "item.minecraft.warped_fungus_on_a_stick": "torz gomba horgászboton",
  "item.minecraft.nether_star": "nethercsillag",
  "item.minecraft.pumpkin_pie": "tökpite",
  "item.minecraft.firework_rocket": "tűzijáték",
  "item.minecraft.firework_star": "tűzijátékcsillag",
  "item.minecraft.enchanted_book": "varázskönyv",
  "item.minecraft.nether_brick": "nethertégla",
  "item.minecraft.quartz": "netherkvarc",
  "item.minecraft.tnt_minecart": "tnt-csille",
  "item.minecraft.hopper_minecart": "tölcséres csille",
  "item.minecraft.prismarine_shard": "prizmarinszilánk",
  "item.minecraft.prismarine_crystals": "prizmarinkristály",
  "item.minecraft.rabbit": "nyers nyúlhús",
  "item.minecraft.cooked_rabbit": "sült nyúlhús",
  "item.minecraft.rabbit_stew": "nyúlpörkölt",
  "item.minecraft.rabbit_foot": "nyúlláb",
  "item.minecraft.rabbit_hide": "nyúlbőr",
  "item.minecraft.armor_stand": "páncélállvány",
  "item.minecraft.iron_horse_armor": "vas lópáncél",
  "item.minecraft.golden_horse_armor": "arany lópáncél",
  "item.minecraft.diamond_horse_armor": "gyémánt lópáncél",
  "item.minecraft.leather_horse_armor": "bőr lópáncél",
  "item.minecraft.lead": "lasszó",
  "item.minecraft.name_tag": "cédula",
  "item.minecraft.command_block_minecart": "parancsblokk-csille",
  "item.minecraft.mutton": "nyers birkahús",
  "item.minecraft.cooked_mutton": "sült birkahús",
  "block.minecraft.white_banner": "fehér zászló",
  "block.minecraft.orange_banner": "narancssárga zászló",
  "block.minecraft.magenta_banner": "bíbor zászló",
  "block.minecraft.light_blue_banner": "világoskék zászló",
  "block.minecraft.yellow_banner": "sárga zászló",
  "block.minecraft.lime_banner": "világoszöld zászló",
  "block.minecraft.pink_banner": "rózsaszín zászló",
  "block.minecraft.gray_banner": "szürke zászló",
  "block.minecraft.light_gray_banner": "világosszürke zászló",
  "block.minecraft.cyan_banner": "türkizkék zászló",
  "block.minecraft.purple_banner": "lila zászló",
  "block.minecraft.blue_banner": "kék zászló",
  "block.minecraft.brown_banner": "barna zászló",
  "block.minecraft.green_banner": "zöld zászló",
  "block.minecraft.red_banner": "vörös zászló",
  "block.minecraft.black_banner": "fekete zászló",
  "item.minecraft.end_crystal": "endkristály",
  "item.minecraft.chorus_fruit": "refréngyümölcs",
  "item.minecraft.popped_chorus_fruit": "pattogatott refréngyümölcs",
  "item.minecraft.beetroot": "cékla",
  "item.minecraft.beetroot_seeds": "céklamag",
  "item.minecraft.beetroot_soup": "céklaleves",
  "item.minecraft.dragon_breath": "sárkánylehelet",
  "item.minecraft.splash_potion": "nem főzhető robbanó bájital□nincs hatás",
  "item.minecraft.spectral_arrow": "spektrálnyíl",
  "item.minecraft.tipped_arrow": "nem elkészíthető varázsnyíl□nincs hatás",
  "item.minecraft.lingering_potion": "nem főzhető időző bájital□nincs hatás",
  "item.minecraft.shield": "pajzs",
  "item.minecraft.elytra": "kitinszárny",
  "item.minecraft.spruce_boat": "fenyőfa csónak",
  "item.minecraft.birch_boat": "nyírfa csónak",
  "item.minecraft.jungle_boat": "dzsungelfa csónak",
  "item.minecraft.acacia_boat": "akáciafa csónak",
  "item.minecraft.dark_oak_boat": "sötéttölgy csónak",
  "item.minecraft.totem_of_undying": "életmentés toteme",
  "item.minecraft.shulker_shell": "shulkerhéj",
  "item.minecraft.iron_nugget": "vasrög",
  "item.minecraft.knowledge_book": "tudás könyve",
  "item.minecraft.debug_stick": "debugpálca",
  "item.minecraft.music_disc_13": "hanglemez□c418 - 13",
  "item.minecraft.music_disc_cat": "hanglemez□c418 - cat",
  "item.minecraft.music_disc_blocks": "hanglemez□c418 - blocks",
  "item.minecraft.music_disc_chirp": "hanglemez□c418 - chirp",
  "item.minecraft.music_disc_far": "hanglemez□c418 - far",
  "item.minecraft.music_disc_mall": "hanglemez□c418 - mall",
  "item.minecraft.music_disc_mellohi": "hanglemez□c418 - mellohi",
  "item.minecraft.music_disc_stal": "hanglemez□c418 - stal",
  "item.minecraft.music_disc_strad": "hanglemez□c418 - strad",
  "item.minecraft.music_disc_ward": "hanglemez□c418 - ward",
  "item.minecraft.music_disc_11": "hanglemez□c418 - 11",
  "item.minecraft.music_disc_wait": "hanglemez□c418 - wait",
  "item.minecraft.music_disc_pigstep": "hanglemez□lena raine – pigstep",
  "item.minecraft.trident": "szigony□□domináns kézben tartva:□+8 sebzés□-2.9 támadási sebesség",
  "item.minecraft.phantom_membrane": "fantommembrán",
  "item.minecraft.nautilus_shell": "nautiluszhéj",
  "item.minecraft.heart_of_the_sea": "tenger szíve",
  "item.minecraft.crossbow": "számszeríj",
  "item.minecraft.suspicious_stew": "gyanús pörkölt",
  "block.minecraft.loom": "szövőszék",
  "item.minecraft.flower_banner_pattern": "zászlóminta□virág címerkép",
  "item.minecraft.creeper_banner_pattern": "zászlóminta□creeper címerkép",
  "item.minecraft.skull_banner_pattern": "zászlóminta□koponya címerkép",
  "item.minecraft.mojang_banner_pattern": "zászlóminta□mojang címerkép",
  "item.minecraft.globe_banner_pattern": "zászlóminta□földgömb",
  "item.minecraft.piglin_banner_pattern": "zászlóminta□disznóorr",
  "block.minecraft.composter": "komposztáló",
  "block.minecraft.barrel": "hordó",
  "block.minecraft.smoker": "füstölő",
  "block.minecraft.blast_furnace": "kohó",
  "block.minecraft.cartography_table": "térképasztal",
  "block.minecraft.fletching_table": "íjászasztal",
  "block.minecraft.grindstone": "köszörűkő",
  "block.minecraft.lectern": "olvasóállvány",
  "block.minecraft.smithing_table": "kovácsasztal",
  "block.minecraft.stonecutter": "kővágó",
  "block.minecraft.bell": "harang",
  "block.minecraft.lantern": "lámpás",
  "block.minecraft.soul_lantern": "léleklámpás",
  "item.minecraft.sweet_berries": "édes bogyók",
  "block.minecraft.campfire": "tábortűz",
  "block.minecraft.soul_campfire": "lélektábortűz",
  "block.minecraft.shroomlight": "fényspóra",
  "item.minecraft.honeycomb": "méhsejt",
  "block.minecraft.bee_nest": "méhkas",
  "block.minecraft.beehive": "méhkaptár",
  "item.minecraft.honey_bottle": "mézespalack",
  "block.minecraft.honey_block": "mézblokk",
  "block.minecraft.honeycomb_block": "méhsejtblokk",
  "block.minecraft.lodestone": "iránykő",
  "block.minecraft.netherite_block": "netheritblokk",
  "block.minecraft.ancient_debris": "ősi törmelék",
  "block.minecraft.target": "céltábla",
  "block.minecraft.crying_obsidian": "könnyező obszidián",
  "block.minecraft.blackstone": "feketekő",
  "block.minecraft.blackstone_slab": "feketekő lap",
  "block.minecraft.blackstone_stairs": "feketekő lépcső",
  "block.minecraft.gilded_blackstone": "aranyozott feketekő",
  "block.minecraft.polished_blackstone": "csiszolt feketekő",
  "block.minecraft.polished_blackstone_slab": "csiszolt feketekő lap",
  "block.minecraft.polished_blackstone_stairs": "csiszolt feketekő lépcső",
  "block.minecraft.chiseled_polished_blackstone": "vésett csiszolt feketekő",
  "block.minecraft.polished_blackstone_bricks": "csiszolt feketekőtégla",
  "block.minecraft.polished_blackstone_brick_slab": "csiszolt feketekőtégla lap",
  "block.minecraft.polished_blackstone_brick_stairs": "csiszolt feketekőtégla-lépcső",
  "block.minecraft.cracked_polished_blackstone_bricks": "repedt csiszolt feketekőtégla",
  "block.minecraft.respawn_anchor": "újraéledés-kapocs",
}
export const hu_hu = items; 
